import Main from './Components/Main'
import React from 'react'


const App=()=> {
  
  return (
    <>
    

      <Main/>

      {/* <Data/> */}
     
    </>
  );
}

export default App;